module.exports = __webpack_public_path__ + "static/media/brake-inspection-red.f42fbc6a.svg";